var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.365448,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2522",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.365448,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2522)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.7821,
    width: 7.33333,
    height: 16,
    fill: "#E43D4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.115448 16H7.44878V0H0.115448V16Z",
    fill: "#1BB65D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.b5dfb94fd4a3f94ddf89d514365a6dc1.svg";
export { ForwardRef as ReactComponent };